var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"textarea",class:_vm.classes,domProps:{"value":_vm.value},on:{"change":_vm.runValidations,"keyup":_vm.runValidations,"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }